// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-70026cc7] .leader-data .el-form .is-disabled * {\n  color: blue !important;\n}\n[data-v-70026cc7] .el-upload .el-button {\n  display: none !important;\n}\n[data-v-70026cc7] .el-upload-list__item-status-label {\n  display: none !important;\n}\n[data-v-70026cc7] .el-icon-close {\n  display: none !important;\n}\n.full-height[data-v-70026cc7] {\n  position: relative;\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
